import * as R from 'ramda';

export default {
  GET: giftVoucher => {
    return (dispatch, getState) => {
      return R.indexBy(R.prop('id'), giftVoucher);
    };
  }
};